'use client'

import type { ReactNode } from 'react'

import Link from '@/components/client/seo/link'

interface RowIdentityProps {
  id: string
  brandName: string
  fullName: string
  href: string
  children: ReactNode
}

// Keep the brand and model in one heading without repeating a brand already
// included in the release name.
export const RowIdentity = ({ id, brandName, fullName, href, children }: RowIdentityProps) => {
  const nameHasBrand =
    fullName.toLowerCase() === brandName.toLowerCase() ||
    fullName.toLowerCase().startsWith(`${brandName.toLowerCase()} `)
  const displayName = brandName && !nameHasBrand ? `${brandName} ${fullName}` : fullName

  return (
    <div className="col-start-2 row-start-1 flex min-w-0 flex-col items-start gap-1 self-start md:gap-2">
      <h3 id={id} className="text-[18px] leading-[1.2] font-semibold tracking-[-0.01em] wrap-break-word md:text-[20px]">
        <Link
          href={href}
          prefetch={false}
          data-tracking="ignore"
          className="text-navy focus-visible:outline-lapis no-underline underline-offset-4 hover:underline focus-visible:outline-2 focus-visible:outline-offset-2"
        >
          {displayName}
        </Link>
      </h3>
      {children}
    </div>
  )
}
